import { Component, NgZone, OnInit, OnDestroy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';

import { AhsTranslationService } from '@nx-ahs/base-translate';
import { AHSTripettoComponent } from '@nx-ahs/script-collector';
import { LanguageService } from '../../../core/services/language.service';

@Component({
	selector: 'recaptcha',
	templateUrl: './recaptcha.component.html',
	styleUrls: ['./recaptcha.component.scss'],
	standalone: false
})
export class RecaptchaComponent extends AHSTripettoComponent implements OnInit, OnDestroy {
	@Output() resolved = new EventEmitter<string | null>();

	public captchaPassed = false;
	public captchaResponse: string | null = null;
	public showCaptcha = true;

	private refreshTimer: any;

	constructor(
		private translateService: AhsTranslationService,
		private languageService: LanguageService,
		private zone: NgZone,
		private cdr: ChangeDetectorRef
	) {
		super();
	}

	async ngOnInit(): Promise<void> {
		await this.loadTranslations();

		const existingValue = this.getTripettoValue();

		if (existingValue === 'true') {
			this.captchaPassed = true;
			return;
		}

		this.startCaptchaRefreshTimer();
	}

	ngOnDestroy(): void {
		clearInterval(this.refreshTimer);
	}

	public async loadTranslations(): Promise<void> {
		const languages = await this.languageService.getLanguagesForPublicPage('register').toPromise();

		this.translateService.loadTranslations(...languages.locales);
	}

	captchaResolved(response: string | null): void {
		this.zone.run(() => {
			const valid = !!response;

			this.captchaPassed = valid;
			this.captchaResponse = response;

			this.setTripettoValue('true');
			this.resolved.emit(response);
		});
	}

	captchaError(): void {
		this.rebuildCaptcha();
	}

	private startCaptchaRefreshTimer(): void {
		// 110 Refresh every 110 seconds - google's timeout is 120
		this.refreshTimer = setInterval(() => {
			if (!this.captchaPassed) {
				this.rebuildCaptcha();
			}
		}, 110000);
	}

	private rebuildCaptcha(): void {
		this.zone.run(() => {
			this.showCaptcha = false;

			this.captchaPassed = false;
			this.captchaResponse = null;

			this.setTripettoValue('false');
			this.resolved.emit(null);

			this.cdr.detectChanges();

			setTimeout(() => {
				this.showCaptcha = true;

				this.cdr.detectChanges();
			}, 50);
		});
	}
}
